var React = require('react');

function UiPlus2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M64,37.31a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V26.69a3,3,0,0,1,3-3H61a3,3,0,0,1,3,3Z","key":0}),React.createElement("path",{"d":"M37.31,64a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3H26.69a3,3,0,0,0-3,3V61a3,3,0,0,0,3,3Z","key":1})]);
}

UiPlus2.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 64 64"};

module.exports = UiPlus2;

UiPlus2.default = UiPlus2;
